import gql from 'graphql-tag';

import type { BlogOutlineSection } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderOutlineSection(
    $id: ID!
    $headline: String!
    $content: String
    $keywordsUsage: JSON
    $manualKeywords: [String!]
    $instructions: String
    $generationLength: BlogOutlineSectionGenerationLengthEnum
  ) {
    updateBlogPostBuilderOutlineSection(
      id: $id
      headline: $headline
      content: $content
      keywordsUsage: $keywordsUsage
      manualKeywords: $manualKeywords
      instructions: $instructions
      generationLength: $generationLength
    ) {
      ...BlogPostBuilderOutlineSection
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

interface Params {
  id: ID;
  headline: string;
  content: string;
  keywordsUsage?: any;
  manualKeywords?: string[];
  instructedWriting?: string;
  generationLength?: string;
}

export const updateBlogPostBuilderOutlineSection = async ({
  id,
  headline,
  content,
  keywordsUsage,
  manualKeywords,
  instructedWriting,
  generationLength,
}: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      id,
      headline,
      content,
      keywordsUsage: keywordsUsage ? JSON.stringify(keywordsUsage) : null,
      manualKeywords,
      instructions: instructedWriting,
      generationLength,
    },
  });

  return getSingleProp<BlogOutlineSection>(result.data);
};
